import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import UserRepository from '@/repositories/userRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useUserStore = defineStore({
    id: 'user',
    state: () => ({
        CompanyNm: '',
        NameKj: '',
        MailAddress: '',
        AuthenticateMethod: '',
        CompanyId: '',
        UserId: '',
    }),
    getters: {},
    actions: {
        /**
         * ユーザー情報取得API
         * @param {String} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getUserAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const userRepository = new UserRepository();
            try {
                const response = await userRepository.getUserApi(API_URL, requestBody, idToken);
                this.CompanyNm = response.data.CompanyNm;
                this.NameKj = response.data.NameKjLs === '' ? response.data.NameKjFs : response.data.NameKjLs + ' ' + response.data.NameKjFs;
                this.MailAddress = response.data.MailAddress;
                this.AuthenticateMethod = response.data.AuthenticateMethod;
                this.CompanyId = response.data.CompanyId;
                this.UserId = response.data.UserId;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        reset() {
            this.CompanyNm = '';
            this.NameKj = '';
            this.MailAddress = '';
            this.AuthenticateMethod = '';
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
